import ButtonParameters from "../../IButtonParameters";

export default class LabelParameters extends ButtonParameters {
    private _label: string;

    public constructor(right: string, datas?: any) {
        super(right, datas);
        this._label = datas?.label ?? "Label non défini";
    }

    /** Label du bouton */
    public get Label(): string {
        return this._label;
    }
}

export class Empty extends LabelParameters {
    public constructor(right) {
        super(LabelParameters.GetRight(right, ''), {label: ''});
    }
}

export class Edit extends LabelParameters {
    public constructor(right) {
        super(LabelParameters.GetRight(right, 'Write'), {label: 'Edit'});
    }
}

export class Save extends LabelParameters {
    public constructor(right) {
        super(LabelParameters.GetRight(right, 'Write'), {label: 'Save'});
    }
}

export class Delete extends LabelParameters {
    public constructor(right) {
        super(LabelParameters.GetRight(right, 'Delete'), {label: 'Delete'});
    }
}

export class Publish extends LabelParameters {
    public constructor(right) {
        super(LabelParameters.GetRight(right, 'Write'), {label: 'Publish'});
    }
}

export class Archive extends LabelParameters {
    public constructor(right) {
        super(LabelParameters.GetRight(right, 'Write'), {label: 'Archive'});
    }
}

export class Erase extends LabelParameters {
    public constructor(right) {
        super(LabelParameters.GetRight(right, 'Write'), {label: 'Erase'});
    }
}

export class SelectAll extends LabelParameters {
    public constructor(right) {
        super(LabelParameters.GetRight(right, 'Read'), {label: 'SelectAll'});
    }
}

export class Excel extends LabelParameters {
    public constructor(right) {
        super(LabelParameters.GetRight(right, 'Read'), {label: 'ExcelExport'});
    }
}

export class Cancel extends LabelParameters {
    public constructor(right) {
        super(LabelParameters.GetRight(right, 'Read'), {label: 'Cancel'});
    }
}

export class Close extends LabelParameters {
    public constructor(right) {
        super(LabelParameters.GetRight(right, 'Read'), {label: 'Close'});
    }
}

// Liste de tous les types de bouton possible.
export const ButtonActionEnum: { [key: string]: typeof ButtonParameters } = {
    Empty: Empty,
    Edit: Edit,
    Delete: Delete,
    Publish: Publish,
    Archive: Archive,
    Erase: Erase,
    SelectAll: SelectAll,
    Excel: Excel,
    Cancel: Cancel,
    Close: Close,
}
